import React, { memo } from 'react';

import './LateCancellation.scss';

const LateCancellation = () => {
	return <div className="late__cancellation--badge">LATE CANCELLATION</div>;
};

export default memo(LateCancellation);
